import { makeStyles } from "tss-react/mui";
import { Theme } from "@mui/material/styles";

import { Nullable } from "@/types/common";

const getBackground = (
  theme: Theme,
  isLora: boolean,
  rank?: Nullable<number>
) => {
  if (isLora) {
    return theme.palette.secondary.light;
  }

  if (rank) {
    if (rank === 1)
      return "linear-gradient(45deg, rgba(255, 215, 0, 0.8),rgba(218, 165, 32, 0.8),rgba(255, 223, 0, 0.9),rgba(218, 165, 32, 0.8), rgba(255, 215, 0, 0.8))";
    if (rank === 2)
      return "linear-gradient(45deg, rgba(192, 192, 192, 0.8), rgba(169, 169, 169, 0.8), rgba(211, 211, 211, 0.9), rgba(169, 169, 169, 0.8), rgba(192, 192, 192, 0.8))";
    if (rank === 3)
      return "linear-gradient(45deg, rgba(205, 127, 50, 0.8), rgba(139, 69, 19, 0.8), rgba(205, 133, 63, 0.9), rgba(139, 69, 19, 0.8), rgba(205, 127, 50, 0.8))";
  }

  return "#ececec";
};

export const useStyles = makeStyles<{
  isLora: boolean;
  interactive: boolean;
  rank?: Nullable<number>;
}>()((theme, { isLora, interactive, rank }) => ({
  link: {
    textDecoration: "none",
    color: isLora || rank === 3 ? "#ffffff" : theme.palette.primary.main,
  },
  tag: {
    background: getBackground(theme, isLora, rank),
    color: isLora || rank === 3 ? "#ffffff" : theme.palette.primary.main,
    "&:hover": {
      opacity: isLora || !interactive ? 1 : 0.8,
      background: isLora
        ? theme.palette.secondary.main
        : getBackground(theme, isLora, rank),
    },
  },
}));
